import React from 'react';
import Modal from 'components/Forms/FormModal/Modal';
import Toaster from 'components/Toaster';
import { removeSwineMortality } from 'containers/AgroBRF/FlockList/service';
import t from 'components/i18n';

export default function SwineMortalityModals({
  success,
  selectedKey,
  setSelectedKey,
  deceasedResponse,
  setDeceasedResponse,
  setUpdateItems,
  setSelectedDeceased,
  displayExcludeModal,
  selectedDeceased,
  setDisplayExcludeModal,
  setSendToConfirmation,
  setRemoved,
  removed,
  goTo,
}) {
  async function removeItem(id) {
    try {
      const response = await removeSwineMortality(id);
      setRemoved(response.success);
      if (selectedKey !== 'deceasedSummary') {
        setSelectedKey('deceasedSummary');
      }
    } catch (e) {
      console.error('Fetch error', e);
    }
  }

  return (
    <>
      {/* Success or fail modal */}
      <Modal
        opened={deceasedResponse !== null}
        confirm={() => {
          // TODO: edit this to use the new response false
          goTo('deceasedSummary');
          setSendToConfirmation(false);
          setDeceasedResponse(null);
          setUpdateItems(true);
          setSelectedDeceased(null);
        }}
        deny={() => setDeceasedResponse(null)}
        onCloseModal={() => {
          setDeceasedResponse(null);
          setSelectedDeceased(null);
        }}
        warning={!success}
        noButtons={!success}
      >
        <span
          className={`icon icon-${
            success ? 'check' : 'exclamation-triangle'
          }`}
        />
        <h4>{success ? t('next.swineRecord.mortalityModals.title.success') : t('next.swineRecord.mortalityModals.title.error')}</h4>

        <p>
          {success
            ? t('next.swineRecord.mortalityModals.message.success')
            : deceasedResponse}
        </p>
      </Modal>
      {/* \ Success or fail modal */}

      {/* Exclude item modal */}
      <Modal
        warning
        opened={displayExcludeModal && selectedDeceased}
        confirm={() => {
          removeItem(selectedDeceased.id);
          setDisplayExcludeModal(false);
          setUpdateItems(removed);
        }}
        deny={() => setDisplayExcludeModal(false)}
      >
        <span className="icon icon-exclamation-triangle" />
        <h4>{t('next.swineRecord.mortalityModals.exclude.title')}</h4>
        {/* <p>{cadecSubmitResponse}</p> */}
        <p>
          {t('next.swineRecord.mortalityModals.exclude.subtitle')}
        </p>
      </Modal>
      {/* \ Exclude item modal */}

      <Toaster
        className="toaster__notification"
        isVisible={removed}
        color="success"
        duration={3}
        delay={0}
      >
        <span className="icon icon-check" />{t('next.swineRecord.mortalityModals.exclude.toast.success')}
      </Toaster>
    </>
  );
}
